import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, Table,CardHeader, } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
// import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


toast.configure();

const Invoice = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
 
  const [Invoice_detail, setInvoice_detail] = useState([])
  const [clientHeight, setclientHeight] = useState("")
  

 
 

  useEffect(() => {
    if(localStorage.getItem("usertype")!== "Supplier"){
      window.history.back()
    }
    

    getInvoiceDetail()
  }, [Invoice_detail])

  async function getInvoiceDetail() {
    let { data: Invoice_Details, error } = await supabase
      .from('invoice_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))
      .order('id', { ascending: false })

    if (Invoice_Details !== null && Invoice_Details.length > 0) {
      setInvoice_detail(Invoice_Details)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.77)

      }, 1000)
    } else {
      // toast.error("No Buyer Details Found")
      if(error){}
      setInvoice_detail([])
    }
  }
  async function updateInvoice(id) {
   
    window.localStorage.setItem("invoice", id)
    window.location.href = "/Invoice/"+ id+`/${window.localStorage.getItem("usertype")}`
   
  }



  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function convertdata(Invoicedate) {
    var date = new Date(Invoicedate)
    var day_date = date.getDate()
    var month = date.getMonth()
    var day = date.getDay()


    var newdate = dayNames[day] + "-" + day_date + "-" + monthNames[month]
    return newdate
  }



  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Invoice Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12" id="maintrip" style={window.innerWidth<800?{paddingLeft:'5px',paddingRight:"5px"}:{width:"100%"}}>
          {window.innerWidth < 800 ? <>
             

            <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll",padding:"5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {Invoice_detail.length > 0 ? <>
                      {Invoice_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px", width: "50px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.invoice_date).split("-")[0]}</div><div style={{ fontWeight: "700",fontSize:"18px" }}>{convertdata(data.invoice_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.invoice_date).split("-")[2]}</div></div>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Bill To</span>
                                        <span style={{ display: "block" }}>{data.customer_name}</span>
                                        <span style={{ display: "block" }}>{data.customer_address}</span>
                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#ba78e3", padding: "10px", cursor: "pointer" }} onClick={() => {
                                  updateInvoice(data.invoice_id)
                                }}><Icon icon="carbon:view-filled" color="#a927f9" width="20" height="20" /></div>
                                  &nbsp;
                                 



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" style={{ alignItems: "center " }}>

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Buyer</span>
                                      <span style={{ display: "block" }}>{data.customer_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                      <span style={{ display: "block" }}>{data.inventory_type}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                      <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                     
                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Supplier</span>
                                      <span style={{ display: "block" }}>{data.man_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                      <span style={{ display: "block" }}>{data.inventory_quantity}  {data.inventory_unit}</span>
                                      
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                      <span style={{ display: "block" }}>{data.payment_status}</span>

                                    </div>


                                  </div>
                                  <br />
                                  <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {(parseInt(data.inventory_cost))+(((parseInt(data.inventory_cost))*18)/100)}</span></p>
                                 

                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion></div>
            </> :
            <Card>

             
              <CardBody>
                <div className="table-responsive ">
                  <Table>
                    <thead>
                      <tr style={{textAlign:"center"}}>
                        <th scope="col">{"Date"}</th>
                        {/* <th scope="col">{"Vehicle"}</th> */}
                        <th scope="col">{"Buyer"}</th>
                        <th scope="col">{"Buyer Address"}</th>
                        <th scope="col">{"Inventory"}</th>
                        <th scope="col">{"Quantity"}</th>
                      




                        <th scope="col">{"Supplier"}</th>
                        <th scope="col">{"Inventory Cost"}</th>
                       
                        <th scope="col">{"Total Cost"}</th>

                        <th scope="col">{"Payment"}</th>
                        <th scope="col">{"Action"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Invoice_detail.length > 0 ? <>
                        {Invoice_detail.map((data, i) => {
                          return (
                            <tr key={i} style={{textAlign:"center"}}>
                              <td style={{display:"flex",justifyContent:"center"}}>
                                <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px", width: "50px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.invoice_date).split("-")[0]}</div><div style={{ fontWeight: "700",fontSize:"18px" }}>{convertdata(data.invoice_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.invoice_date).split("-")[2]}</div></div>
                                </td>
                              {/* <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "500" }}>{data.vehicle_number.substring(6, 10)}</div></div></td> */}
                              <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span></td>
                              <td>{data.customer_address}</td>
                              <td>{data.inventory_type}</td>
                              <td>{data.inventory_quantity}</td>
                             


                              <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.man_name}</span></td>
                              <td>{data.inventory_cost}</td>
                            
                              <td>{(parseInt(data.inventory_cost))+(((parseInt(data.inventory_cost))*18)/100)}</td>
                              {/* <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td> */}

                              <td>{data.payment_status === "Paid" ? <span style={{ textTransform: "uppercase", backgroundColor: "darkgreen", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "orange", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span>}</td>

                              <td><button className='btn btn-info' onClick={() => {
                                updateInvoice(data.invoice_id)
                                
                              }}><i className='fa fa-eye '></i> View</button></td>
                            </tr>
                          )
                        })}
                      </>
                        : <tr style={{textAlign:"center"}}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}

                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Invoice;